import React from 'react';
import makeLoadable from '@loadable/component';
import RouterLoader from './RouterLoader';
import {routePaths} from './route-paths';
import Auth0Callback from '@/auth/Auth0Callback';
import Login from '@/auth/Login';
import LoginOrRedirect from '../auth/LoginOrRedirect';
import SmsPermissions from 'pages/sms-permissions';

export function loadable(module) {
    return makeLoadable(module, {fallback: <RouterLoader />});
}

const componentsByPath = {
    '/auth/callback': Auth0Callback,
    '/auth/restricted-login': Login,
    '/login': Login,
    '/auth/partner-login': LoginOrRedirect,
    '/sms-permissions': SmsPermissions,
};

const routes = routePaths.map(routePath => ({
    ...routePath,
    component: componentsByPath[routePath.path],
}));

export default routes;
